<template>
	<div>
		<div>
			<headers :headerActive="true"></headers>
			<div class="content">
				<div class="m-t-30 m-b-30">您的位置：课程中心 >  <span class="bg_color">{{name}}</span></div>
				<div class="borders b_bai p-l-40 p-r-40 p-t-40 p-b-40">
					<div class="f-30 color333">{{name}}</div>
					<div class="d_flex d_flex_between m-t-25">
						<div class="color333 f-14 d_flex d_flex_items_center">
							<img :src="teacherImg" class="w-25 h-25">
							<span class="m-l-10">讲师：{{teachername}}</span>
						</div>
						<div class="prices">价格：{{price}}</div>
					</div>
					<div class="m-t-30 timer">
						共{{count}}课时/{{time}}分钟
					</div>
				</div>
				<div class="b_bai p-l-100 p-r-100 p-t-60 p-b-60 m-t-30 m-b-30">
					<div class="f-35 m-b-30 f-wb">课程简介</div>
					<div class="m-b-30 color333 f-18 lh-50">{{desc}}</div>
					<img :src="banner" class="banner_style">
				</div>
			</div>
		</div>
		<div>
			<bottoms></bottoms>
		</div>
	</div>
</template>

<script>
	import headers from './common/header.vue'
	import bottoms from './common/bottoms.vue'
	export default{
		components:{
			headers,
			bottoms
		},
		data(){
			return{
				desc:"",
				name:"",
				teachername:"",
				price:"",
				count:"",
				time:"",
				teacherImg:"",
				banner:""
			}
		},
		mounted(){
			this.getInfo()
		},
		methods:{
			getInfo(){
				this.$http.post('http://aqjd.aqpx.online/getCourseInfos',{
					cid:this.$route.query.id,
					userid:955
				}).then(res=>{
					console.log(res)
					this.name = res.data.info.name
					this.teachername = res.data.info.teachername
					this.price = res.data.info.price
					this.count = res.data.info.count
					this.time = res.data.info.time
					this.teacherImg = res.data.info.headImage
					this.banner = res.data.info.coursesrc
					this.desc = res.data.info.dsc

				})
			}
		}
	}
</script>

<style scoped>
	.borders{
		border:1px solid #e5e5e5;
	}
	.border_b{
		border-bottom: 1px solid #e5e5e5;
	}
	.prices{
		color:#FF0000;
		font-weight: bold;
	}
	.color333{
		color:#333
	}
	.timer{
		color:#999;
		font-size: 14px;
	}
	.banner_style{
		width:40%;
	}
</style>
